import { FunctionComponent } from 'react';
import styles from "./CampaignCard.module.css";
import cn from 'classnames';
import {Image, Card, Dropdown} from 'react-bootstrap';
import { ASSESTS } from '../../../constant/assest';
import { ICampaignStatus } from '../../../constant/enums';


interface ICampaignCardProps {
    icon: string | React.ReactElement | React.ReactNode;
    title: string;
    status: ICampaignStatus;
    tag: string;
    date: string;
    user: string;
    onDelete?: () => void;
    onView?: () => void;
    onEdit?: () => void;
    onClone?: () => void;
    className?: string;
};

const CampaignCard: FunctionComponent<ICampaignCardProps> = ({status, icon, title, tag, date, user, onDelete, onView, onEdit, onClone, className }) => {

    return (
        <Card bsPrefix={cn(styles.campaignCard, className)} onClick={onView}>
            <Card.Header bsPrefix={styles.header}>
                <div className={cn(styles.headerCol, styles.titleCol)}>
                    <div className={styles.image}>
                        {icon}
                    </div>
                    <div className={styles.content}>
                        <Card.Title as={'div'} bsPrefix={styles.title}>{title}</Card.Title>
                    </div>
                </div>
                <div className={cn(styles.headerCol, styles.optionCol)}>
                    <div className={styles.option}>
                        <Dropdown className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                            <Dropdown.Toggle variant='light' className={styles.dropdownBtn}>
                                <Image src={ASSESTS.THREEDOTREFERAL} alt='Option' width={30} height={30} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={styles.listIconDopdown}>
                                <div className={styles.listIconDopdownBody}>
                                    <Dropdown.Item bsPrefix={styles.listIconDopdownItem} onClick={onClone}>
                                        <div className={styles.icon}><Image src={ASSESTS.CLONE} alt='Clone' width={18} height={18} /></div> Clone</Dropdown.Item>
                                    <Dropdown.Item bsPrefix={cn(styles.listIconDopdownItem, styles.logoutBtn)} onClick={onEdit}><Image src={ASSESTS.EDITCOMPAIGN} alt='Edit' width={26} height={24} /> Edit</Dropdown.Item>
                                    <Dropdown.Item bsPrefix={cn(styles.listIconDopdownItem, styles.logoutBtn)} onClick={onDelete}><Image src={ASSESTS.DELETEICONLIST} alt='Delete' width={26} height={24} /> Delete</Dropdown.Item>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </Card.Header>
            <Card.Body bsPrefix={styles.body}>
                <span className={cn(styles.status, styles[status || ''])}>
                    {status === ICampaignStatus.ACTIVE ? 'Active' : status === ICampaignStatus.EXPIRE ? 'Expired' : status === ICampaignStatus.SCHEDULED ? 'Scheduled' : 'In Active'}
                </span>
                <div className={styles.tag}>{tag}</div>
            </Card.Body>
            <Card.Footer bsPrefix={styles.foorer}>
                <span className={cn(styles.label, styles.date)}><Image src={ASSESTS.DATE} alt='Date' width={16} height={16} />{date}</span>
                <span className={cn(styles.label, styles.user)}><Image src={ASSESTS.ALLUSER} alt='User' width={16} height={16} />{user}</span>
            </Card.Footer>
        </Card>
    );
};

export default CampaignCard;
